import mediabox from 'mediabox'
import 'mediabox/src/mediabox.css'

mediabox('.mediabox'); // Additional options